var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"count-down"},[_c('span',{staticStyle:{"margin-right":"10px"}},[_vm._v(_vm._s(_vm.timeText))]),_c('span',{on:{"click":_vm.countEvent}},[_vm._v(_vm._s(_vm.countDownList))])])
}
var staticRenderFns = []

export { render, staticRenderFns }